import React from 'react';
import PropTypes from 'prop-types';

export default function PaymentTerms({ submitLabel }) {
  return (
    <p className="donation-terms" data-testid="donation-terms">
      By clicking &ldquo;{submitLabel},&rdquo; I confirm that I have read and accept the{' '}
      <a href="https://www.opendate.io/terms" target="_blank" rel="noopener noreferrer">Terms of Service</a>,{' '}
      <a href="https://www.opendate.io/privacy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>{' '}
      and Refund Policy. I also agree that Opendate may share my information with the organizer.
    </p>
  );
}

PaymentTerms.propTypes = {
  submitLabel: PropTypes.string.isRequired,
};
